import React from 'react';
import { connect } from 'react-redux';

import ManageDestinationPresenter from './ManageDestinationPresenter';

// Redux
import { fetchDropdownLocations } from '../locations/redux/_actions';
import { initDestination, fetchCreateDestination } from './redux/_actions';

class CreateDestinationContainer extends React.Component {
    componentDidMount() {
        this.props.initDestination();
        this.props.fetchDropdownLocations({ format: 'dropdown' });
    }

    onSubmit(form_props) {
        this.props.fetchCreateDestination(form_props).then(response => {
            if (response) {
                this.props.history.push('/itineraries');
            }
        });
    }

    render() {
        return (
            <ManageDestinationPresenter
                match={this.props.match}
                history={this.props.history}
                dropdown_locations={this.props.dropdown_locations}
                onSubmit={this.onSubmit.bind(this)}
            />
        );
    }
}

const mapStateToProps = state => {
    return {
        dropdown_locations: state.locations.dropdown_locations
    };
};

const mapDispatchToProps = (dispatch, own_props) => {
    return {
        fetchDropdownLocations: params =>
            dispatch(fetchDropdownLocations(params)),
        initDestination: params => dispatch(initDestination(params)),
        fetchCreateDestination: params =>
            dispatch(fetchCreateDestination(params))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateDestinationContainer);
